import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import { notificationSetEnabled } from '../../../../../../../../../rest/effects/notificationSettings/notificationSetEnabled';
import { root } from '../../../../../../../../../store/constants';
import { getNotificationSettingsByBoardId } from '../../../../../../../../../store/model/selectors/getNotificationSettingsByBoardId';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';

export const toggleEnabledEmailNotifications = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const notification = getNotificationSettingsByBoardId(getState(), boardId);
        const setEnabled = !notification || !notification.enabled;
        dispatch(notificationSetEnabled(boardId, setEnabled));
        dispatch(segmentTrackAction(setEnabled ? SegmentBoardEvent.EMAIL_NOTIFICATIONS_ON : SegmentBoardEvent.EMAIL_NOTIFICATIONS_OFF));
        if (setEnabled) {
            root.App.statHelper.sendUserStat({ // todo achtung
                [App.Classes.StatHelper.DASHBOARD_NOTIFICATION_ACTIVATION_DATE]:
                'ifnull' + root.App.Util.nowTrimTimestampGMT()
            });
        }
    }
    return action;
}
